export default __webpack_public_path__ + "static/Quality-2555a6e5532318c1a736e164c7bd516a.png";